<template>
  <thead class="es-sorter">
    <tr>
      <th
        v-for="(columnHeader, index) in columnHeaders"
        :title="columnHeader.header"
        :key="index"
        :style="columnHeader.style"
        :class="{
          'is-hidden-mobile' : columnHeader.hideForMobile,
          'is-hidden-touch' : columnHeader.hideForTablet,
        }">
        <a
          v-if="columnHeader.sortable"
          @click='sort(columnHeader)'
          role="button"
          @keypress='sort(columnHeader)'
          tabindex="0">
          {{ columnHeader.header }}
          <font-awesome-icon
            v-if="columnHeader.order === 'ASC'"
            class="es-duo"
            :icon="['fad', 'sort-up']"
            title="Sort Descending"/>
          <font-awesome-icon
            v-else-if="columnHeader.order === 'DESC'"
            class="es-duo"
            :icon="['fad', 'sort-down']"
            title="Sort Ascending"/>
          <font-awesome-icon
            v-else
            class="es-sort"
            :icon="['fas', 'sort']"
            title="Sort Ascending"/>
        </a>
        <span v-else>
          {{ columnHeader.header }}
        </span>
      </th>
    </tr>
  </thead>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSort,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faSortDown,
  faSortUp,
} from '@fortawesome/pro-duotone-svg-icons';

library.add(
  faSort,
  faSortDown,
  faSortUp,
);

export default {
  props: {
    // pass in object from api response
    apiSorter: {
      type: Object,
    },
    /*
      Create an array of column headers with the following key in each object...
      String header - display the text for the column headers
      String field - string used to pass into api
      String order - the current sort order on one given column
      Boolean sortable - allows the column to be sorted
      Object style - width of the column.
    */
    columnHeaders: {
      type: Array,
      required: true,
    },
  },
  watch: {
    apiSorter() {
      this.checkApiSorter();
    },
  },
  created() {
    if (this.apiSorter && this.apiSorter.field) this.checkApiSorter();
  },
  methods: {
    clearSortOrder() {
      // eslint-disable-next-line no-return-assign
      this.columnHeaders.forEach((columnHeader, i) => this.columnHeaders[i].order = null);
    },
    checkApiSorter() {
      // Check to see if both filed and order are the same
      // If not, find find if the column exists
      if (!this.columnHeaders.filter(header => header.field === this.apiSorter.field
        && header.order === this.apiSorter.order).length
      ) {
        // check to see if column exists
        this.clearSortOrder();
        const matchedField = this.columnHeaders
          .find(header => header.field === this.apiSorter.field);
        if (matchedField) {
          matchedField.order = this.apiSorter.order;
        }
      }
    },
    sort(header) {
      // 1. no order || order is desc => go to asc
      // 2. order is asc => go to desc

      // clear out all other sort orders
      const currentIndex = this.columnHeaders
        .findIndex(columnHeader => columnHeader.field === header.field);
      this.columnHeaders.forEach((columnHeader, i) => {
        if (i === currentIndex) return;
        this.columnHeaders[i].order = null;
      });

      // populate current column header with sort order
      // eslint-disable-next-line no-unused-expressions, no-param-reassign
      (!header.order || header.order === 'DESC') ? header.order = 'ASC' : header.order = 'DESC';
      this.$emit('updateSorter', header);
    },
  },
};
</script>

<style lang="sass">
  .es-sorter
    a
      color: #767676
      &:hover
        text-decoration: none
        color: #767676
        .es-sort
          opacity: .75
      .es-sort
        opacity: .4
</style>
